import useGetCurrencyRate from './use-get-currency-rate'
import useGetCurrentUserCurrency from './use-get-current-user-currency'

const UNIVERSAL_PRICE_BASE_CURRENCY = 'USD'
export const FACTOR_FROM_CENT_TO_UNIT_CURRENCY = 1 / 100

const useUniversalPriceConversion = () => {
  const currency = useGetCurrentUserCurrency()
  const { data: currencyRate } = useGetCurrencyRate(UNIVERSAL_PRICE_BASE_CURRENCY, currency)

  return {
    rate: currencyRate?.rate ? currencyRate.rate : 1,
    currency: currencyRate?.rate ? currency : UNIVERSAL_PRICE_BASE_CURRENCY,
  }
}

export default useUniversalPriceConversion
